import { Dialog, DialogTitle, DialogActions, DialogContent, Card, Button } from '@mui/material';
import CreateForm from './CreateForm';
import { IPackCreate } from '../../../../@types/package';
type Props = {
  open: boolean;
  onClose: () => void;
  onCreate: (payload: IPackCreate) => void;
  onUpdate: (payload: IPackCreate) => void;
  currentData: any;
};
export default function CreateDialog({ open, onClose, currentData, onCreate, onUpdate }: Props) {
  const onSubmit = (payload: IPackCreate) => {
    if (currentData?.id) {
      onUpdate(payload);
    } else {
      onCreate(payload);
    }
  };
  return (
    <Dialog fullWidth maxWidth="md" open={open}>
      <DialogTitle sx={{ pb: 2 }}>{currentData?.id ? 'Cập nhật' : 'Tạo mới'}</DialogTitle>
      <DialogContent sx={{ typography: 'body2' }}>
        <Card sx={{ mb: 3 }} style={{ padding: 15 }}>
          <CreateForm
            onSubmit={onSubmit}
            currentData={currentData}
            isUpdate={currentData !== null}
          />
        </Card>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" color="inherit" onClick={onClose}>
          Hủy
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export { CreateDialog };
